import { useState } from 'react'
import { Alert, Button, Form } from 'react-bootstrap'
import { Link, useSearchParams } from 'react-router-dom'

import PaginaPublica from '../../components/Auth/PaginaPublica'
import api from '../../services/api'
import { mensajeDeError } from '../../utils/registroPublico'

/**
 * Recuperar la contraseña. Dos momentos en la misma ruta:
 *
 * - `/recuperar` → pide el correo y manda la liga (la respuesta es la misma exista o no);
 * - `/recuperar?uid=…&token=…` → la liga del correo: elegir la contraseña nueva.
 */
export default function Recuperar() {
  const [params] = useSearchParams()
  const uid = params.get('uid')
  const token = params.get('token')

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repetida, setRepetida] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')
  const [listo, setListo] = useState('')

  const pedirLiga = async (e) => {
    e.preventDefault()
    setError('')
    setEnviando(true)
    try {
      const r = await api.post('/auth/users/password_reset/', { email: email.trim() })
      setListo(r.data?.message)
    } catch (err) {
      setError(mensajeDeError(err))
    } finally {
      setEnviando(false)
    }
  }

  const cambiar = async (e) => {
    e.preventDefault()
    setError('')
    if (password !== repetida) {
      setError('Las contraseñas no coinciden.')
      return
    }
    setEnviando(true)
    try {
      const r = await api.post('/auth/users/password_reset/confirmar/', { uid, token, password })
      setListo(r.data?.message)
    } catch (err) {
      setError(mensajeDeError(err))
    } finally {
      setEnviando(false)
    }
  }

  let cuerpo
  if (listo) {
    cuerpo = (
      <>
        <Alert variant="success" data-testid="recuperar-listo">{listo}</Alert>
        <Button as={Link} to="/login" className="w-100 login-submit">Ir a iniciar sesión</Button>
      </>
    )
  } else if (uid && token) {
    cuerpo = (
      <Form onSubmit={cambiar}>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group className="mb-3" controlId="recuperarPassword">
          <Form.Label>Contraseña nueva</Form.Label>
          <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password" minLength={8} required />
          <Form.Text>Al menos 8 caracteres, que no sean sólo números.</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="recuperarRepetida">
          <Form.Label>Repítela</Form.Label>
          <Form.Control type="password" value={repetida} onChange={(e) => setRepetida(e.target.value)}
                        autoComplete="new-password" required />
        </Form.Group>
        <Button type="submit" className="w-100 login-submit" disabled={enviando}>
          {enviando ? 'Guardando…' : 'Guardar contraseña'}
        </Button>
      </Form>
    )
  } else {
    cuerpo = (
      <Form onSubmit={pedirLiga}>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group className="mb-3" controlId="recuperarEmail">
          <Form.Label>Tu correo</Form.Label>
          <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email" required />
        </Form.Group>
        <Button type="submit" className="w-100 login-submit" disabled={enviando}>
          {enviando ? 'Enviando…' : 'Mandarme la liga'}
        </Button>
        <p className="small text-center mt-3 mb-0"><Link to="/login">Volver a iniciar sesión</Link></p>
      </Form>
    )
  }

  return (
    <PaginaPublica titulo="Recupera tu acceso" encabezado="Recuperar contraseña">
      {cuerpo}
    </PaginaPublica>
  )
}
